import React from 'react';
import { motion } from 'framer-motion';
import { Eye, ShieldCheck, FileX, Scissors, TrendingUp, PiggyBank, Heart, MessageCircle } from 'lucide-react';
const benefits = [{
  icon: Eye,
  title: 'Claridad en 10 minutos',
  desc: 'Ves exactamente en qué se fue todo'
}, {
  icon: ShieldCheck,
  title: 'Control real en 7 días',
  desc: 'De improvisar a decidir'
}, {
  icon: FileX,
  title: 'Sin Excel ni tecnicismos',
  desc: 'Pasos simples que funcionan'
}, {
  icon: Scissors,
  title: 'Cortas gastos invisibles',
  desc: 'Desde el día 1'
}, {
  icon: TrendingUp,
  title: 'Deuda con avance real',
  desc: 'Método mínimo + ataque'
}, {
  icon: PiggyBank,
  title: 'Ahorro automático',
  desc: 'Tu primer colchón aunque sea pequeño'
}, {
  icon: Heart,
  title: 'Gusticos sin culpa',
  desc: 'Límites claros sin prohibirte la vida'
}, {
  icon: MessageCircle,
  title: 'Menos ansiedad',
  desc: 'Ritual quincenal de 15 min fácil de repetir'
}];
export function Benefits() {
  return <section className="py-12 bg-brand-cream" data-id="element-2">
      <div className="container mx-auto px-4" data-id="element-3">
        <div className="text-center mb-16" data-id="element-4">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-brand-dark mb-4" data-id="element-5">
            Lo que consigues
          </h2>
          <p className="text-brand-text/70 max-w-2xl mx-auto" data-id="element-6">
            Un sistema diseñado para darte paz mental, no para juzgarte.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-7">
          {benefits.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-6 rounded-2xl shadow-sm hover:shadow-md transition-shadow border border-brand-green/5" data-id="element-8">
              <div className="w-12 h-12 bg-brand-green/10 rounded-full flex items-center justify-center mb-4 text-brand-green" data-id="element-9">
                <item.icon className="w-6 h-6" data-id="element-10" />
              </div>
              <h3 className="font-heading font-bold text-lg text-brand-dark mb-2" data-id="element-11">
                {item.title}
              </h3>
              <p className="font-sans text-brand-text/80 text-sm" data-id="element-12">
                {item.desc}
              </p>
            </motion.div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-13">
          <div className="inline-flex items-center gap-2 bg-brand-gold/20 text-brand-dark px-4 py-2 rounded-full text-sm font-medium" data-id="element-14">
            <span className="text-lg" data-id="element-15">🎁</span>
            BONUS: Frases listas para poner límites (copiar/pegar)
          </div>
        </div>
      </div>
    </section>;
}